import { utils } from "../../utils";


// const Action_addToCart = (product, oldCartItems) => (dispatch) => {
const Action_addToCart = (product) => (dispatch, getState) => {

    // const cartItems = this.state.cartItems.slice();

    // console.log('getState().reducer_cart.cartItems:', getState().reducer_cart.cartItems)
    const cartItems = getState().reducer_cart.cartItems?.slice();
    let existedItem = cartItems.find((p) => p._id === product._id)

    if (existedItem) {
        existedItem.count++
    } else {
        cartItems.push({ ...product, count: 1 })
    }

    dispatch({
        type: utils.constants.CART_ITEMS_ADD,
        payload: {
            cartItems
        }
    })

    const sortedProducts = getState().reducer_product.filterProducts.slice();
    let currentProduct = sortedProducts.find((p) => p._id === product._id);

    if (currentProduct.count) {
        currentProduct.count++
    } else {
        currentProduct.count = 1;
    }

    dispatch({
        type: utils.constants.COUNT_PRODUCT_INCREASE_OR_REMOVE,
        payload: {
            sortedProducts: sortedProducts,
            products: getState().reducer_product.products
        }
    })




    localStorage.setItem(utils.constants.localStorage_cart, JSON.stringify(cartItems))


}


// const Action_removeFromCart = (product, oldCartItems) => (dispatch) => {
const Action_removeFromCart = (product) => (dispatch, getState) => {

    const cartItems = getState().reducer_cart.cartItems.filter((p) => p._id !== product._id);

    dispatch({
        type: utils.constants.CART_ITEMS_REMOVE,
        payload: { cartItems }
    });



    // after user remove item from cart - 
    // need to remove the dynamic count prop on filterProp
    const sortedProducts = getState().reducer_product.filterProducts.slice()
    const sortedProductsIndex = sortedProducts.findIndex((p) => p._id === product._id);

    delete sortedProducts[sortedProductsIndex].count

    
    dispatch({
        type: utils.constants.COUNT_PRODUCT_INCREASE_OR_REMOVE,
        payload: {
            sortedProducts,
            products: getState().reducer_product.products.slice(),
        }
    })




    localStorage.setItem(utils.constants.localStorage_cart, JSON.stringify(cartItems));
}



export {
    Action_addToCart,
    Action_removeFromCart,
}